export const DEFAULT_NUMBER_OF_COMPLEXES_PER_PAGE = 6;
export const PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE = 7;
